import React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import "./index.scss";

const CustomModal = ({
  isOpen,
  onClose,
  title,
  titleExtra,
  children,
  maxWidth = "600px",
  showCloseButton = true,
  closeOnOverlayClick = true,
  compact = false,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  const modal = (
    <div
      className="custom-modal-overlay"
      onClick={handleOverlayClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        background: "rgba(15, 23, 42, 0.45)",
      }}
    >
      <div
        className={`custom-modal-container${compact ? " custom-modal-container--compact" : ""}`}
        style={{
          maxWidth,
          margin: "auto",
          width: "100%",
          background: "#ffffff",
          borderRadius: 12,
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
        role="dialog"
        aria-modal="true"
      >
        {(title || titleExtra || showCloseButton) && (
          <div className="custom-modal-header">
            <div className="custom-modal-title-row">
              {title && <h3 className="custom-modal-title">{title}</h3>}
              {titleExtra}
            </div>
            {showCloseButton && (
              <button
                className="custom-modal-close"
                onClick={onClose}
                aria-label="Close modal"
                type="button"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            )}
          </div>
        )}
        <div className="custom-modal-content">{children}</div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
};

CustomModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  titleExtra: PropTypes.node,
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.string,
  showCloseButton: PropTypes.bool,
  closeOnOverlayClick: PropTypes.bool,
  compact: PropTypes.bool,
};

export default CustomModal;
